import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Dashsidebar = ({ isOpen, toggleSidebar }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`dashsidebar ${isOpen ? "open" : "closed"} shadow`}>
      <ul className="sidebar-menu">
        <li>
          <Link to="/dashboard" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-speedometer2"></i> Dashboard
          </Link>
        </li>
        <li>
          <Link to="/user" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-person"></i> User
          </Link>
        </li>
        <li>
          <Link to="/link" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-link"></i> Link
          </Link>
        </li>
        <li>
          <Link to="/deposit" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-wallet2"></i> Deposit
          </Link>
        </li>
        <li>
          <Link to="/withdraw" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-cash-stack"></i> Withdraw
          </Link>
        </li>
        <li>
          <Link to="/Bank" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-bank"></i> Bank List
          </Link>
        </li>
        <li>
          <Link to="/Scanner" onClick={isMobile ? toggleSidebar : undefined}>
          <i class="bi bi-qr-code"></i>Scanner
          </Link>
        </li>
        <li>
          <Link to="/setting" onClick={isMobile ? toggleSidebar : undefined}>
            <i className="bi bi-gear"></i> Setting
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Dashsidebar;
